"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationDataForPreview = void 0;
const class_transformer_1 = require("class-transformer");
const User_1 = require("../models/User");
const SimpleOrder_1 = require("./SimpleOrder");
class AssignationDataForPreview {
    assignationId;
    assignationStatus;
    user;
    simpleOrder;
}
exports.AssignationDataForPreview = AssignationDataForPreview;
__decorate([
    (0, class_transformer_1.Type)(() => User_1.User),
    __metadata("design:type", User_1.User)
], AssignationDataForPreview.prototype, "user", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SimpleOrder_1.SimpleOrder),
    __metadata("design:type", SimpleOrder_1.SimpleOrder)
], AssignationDataForPreview.prototype, "simpleOrder", void 0);
//# sourceMappingURL=AssignationDataForPreview.js.map